import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  paragraph: {
    color: theme.palette.primary.main,
    fontSize: '14px',
  },
  configWrapper: {
    width: '100%',
  },
  button: {
    minWidth: '240px',
    height: 40,
    fontFamily: theme.typography.fontFamily,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  credsField: {
    marginTop: '40px',
  },
  credsHelp: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  credsHelpText: {
    color: theme.palette.textField.main,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  textInput: {
    maxWidth: 302,
    height: 80,
  },
  salesforceButton: {
    textTransform: 'capitalize',
  },
  buttonGroup: {
    display: 'flex',
    gap: 32,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: 40,
    // textAlign: 'center',
  },
  conditional: {
    fontWeight: 400,
    color: theme.palette.primary.main,
    fontSize: '14px',
  },
  detailsConnection: {
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 16,
  },
  detailsConnectionContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 16,
    textWrap: 'nowrap',
    flexWrap: 'wrap',
  },
  detailsConnectionContentChild: {
    display: 'flex',
    gap: 4,
  },
  detailsConnectionTitle: {
    fontWeight: 500,
  },
  detailsConnectionValue: {
    fontWeight: 400,
  },
  detailsConnectionChip: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  disconnectModalConent: {
    fontWeight: 400,
    fontSize: 14,
    color: theme.palette.textField.main,
  },
  lastConnection: {
    fontWeight: 400,
    fontSize: 14,
    color: theme.palette.textField.main,
  },
  dividerMargin: {
    marginBottom: 32,
  },
  switchWrapper: {
    display: 'flex',
    gap: theme.spacing(2),
  },
  textContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}))
